import ArticleVarHeight from "components/articles/ArticleVarHeight"

export default function CoverVarHeight(props) {
  return <ArticleVarHeight {...props} cover />
}
